import { pipe, map, values, path } from 'ramda';
import { FHIR_VALUE_ROLES } from 'constants/userRoles';

export const rolesForAddPractitionerForm = pipe(
  map(role => ({
    value: path(['code', 'coding', '0', 'code'], role),
    label: path(['code', 'text'], role),
  })),
  values,
)(FHIR_VALUE_ROLES);
